import { render } from "./Wheel3.vue?vue&type=template&id=069612b6"
const script = {}
script.render = render

export default script